import { isUndefined } from 'lodash-es'
import { PubNubProvider } from 'pubnub-react'
import { FunctionComponent, ReactNode } from 'react'
import { FeatureFlag, useFetchUserStatusQuery } from '@/api/user-api'
import useFeatureFlags from '@/hooks/use-feature-flags'
import usePubNubClient from '@/utils/hooks/use-pub-nub-client'

interface PubNubWrapperProps {
  children: ReactNode
}

const PubNubWrapper: FunctionComponent<PubNubWrapperProps> = ({ children }) => {
  const { data: userStatus } = useFetchUserStatusQuery()
  const { pubNub: pubNubClient, isFetching: isPubNubFetching } =
    usePubNubClient({
      channels: [`campaign_workspace${userStatus?.currentWorkspaceId}.*`],
    })

  if (isPubNubFetching) {
    return null
  }

  if (isUndefined(pubNubClient)) {
    return children
  }

  return <PubNubProvider client={pubNubClient}>{children}</PubNubProvider>
}

interface ChatroomWrapperProps {
  children: ReactNode
}

const ChatroomWrapper: FunctionComponent<ChatroomWrapperProps> = ({
  children,
}) => {
  const { withFeature } = useFeatureFlags()
  const enableChatroom = withFeature(FeatureFlag.DualWheel)

  if (!enableChatroom) {
    return children
  }

  return <PubNubWrapper>{children}</PubNubWrapper>
}

export default ChatroomWrapper
